import {formatMinToNtcTime, getDefaultTime} from "@/tools/utils";

export default {
  computed: {
    unitMinutes() {
      return this.$store.state.sysConfig.unitMinutes || 10
    },
    // 单场会议可约最晚日期限制
    advanceReservingDays() {
      const {advanceReservingDays} = this.dataSource.chosenRoom || {};
      return advanceReservingDays || this.$store.state.sysConfig.advanceReservingDays
    },
    // 单场会议时长限制
    meetingDurationLimit() {
      const meetingDurationLimit = this.$store.state.sysConfig.meetingDurationLimit || 0;
      if (meetingDurationLimit && meetingDurationLimit < this.unitMinutes) {
        return this.unitMinutes
      }
      return meetingDurationLimit
    },
    dftStartDate() {
      return getDefaultTime(30)
    },
    minDate() {
      return getDefaultTime()
    },
    maxDate() {
      return moment().add(this.advanceReservingDays || 90, "d").endOf('day').toDate()
    },
    minEndDate() {
      return moment(this.dataSource.startTime).add(this.unitMinutes, 'm').toDate()
    },
    maxEndDate() {
      if (this.meetingDurationLimit) {
        return moment(this.dataSource.startTime).add(this.meetingDurationLimit, 'm').toDate()
      }
      return this.maxDate
    },
    timeTips() {
      const tips = [];
      if (this.advanceReservingDays) {
        tips.push(`可提前 ${this.advanceReservingDays}天 预约会议`)
      }
      if (this.meetingDurationLimit) {
        tips.push(`单场会议可预约最长时长为 ${formatMinToNtcTime(this.meetingDurationLimit)}`)
      }
      return tips.join('，')
    },
  },
  watch: {
    "dataSource.startTime": function (val, oldVal) {
      this.dataSource.endTime = moment(val).add(this.dataSource.duration, 'm').toDate();
      // 会议开始时间大于周期会议结束重复时间
      if (this.showPeriodic && oldVal && this.untilDateDiffStartTime < 0) {
        this.dataSource.periodicInfo.untilDate = "";
      }
    },
  },
  methods: {
    checkMeetingTime() {
      const {startTime, endTime} = this.dataSource;
      if (!startTime || !endTime) {
        return '请选择会议时间'
      }
      if (this.advanceReservingDays) {
        const diffDays = moment().startOf('day').diff(moment(startTime).startOf('day'), 'day');
        if (diffDays > this.advanceReservingDays) {
          return `当前会议提前预约时间超出天数限制：${this.advanceReservingDays}`
        }
      }
      if (this.meetingDurationLimit) {
        const diffMin = moment(endTime).diff(moment(startTime), 'm');
        if (diffMin > this.meetingDurationLimit) {
          return `当前会议时长超出单场会议时长限制：${formatMinToNtcTime(this.meetingDurationLimit)}`
        }
      }
    },
  }
}
